/**
 * Formats a timestamp into a human-readable relative or absolute format
 * - Relative for < 24 hours (e.g., "2 minutes ago", "5 hours ago")
 * - Absolute for >= 24 hours (e.g., "Jan 15, 2024 at 3:45 PM")
 */
export const formatTimeAgo = (date: Date | string): string => {
  const timestamp = typeof date === 'string' ? new Date(date) : date;
  const now = new Date();
  const diffMs = now.getTime() - timestamp.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  // Less than 24 hours - show relative time
  if (diffDays < 1) {
    if (diffMinutes < 1) {
      return 'Just now';
    } else if (diffMinutes < 60) {
      return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`;
    } else {
      return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    }
  }

  // 24 hours or more - show absolute time
  return timestamp.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};
